/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserPlayIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABpUlEQVR4nOVVTUrDUBCOuBAXIi7c6borwY0HEBGK7ZuZLJ4zrffQhRtBCnoDj2BLwRNoVfAMnsDShYq2/myklXlJayRNY0m78sEQSF6+b+b7vpd43r9YiLwKxHVD0tYC4gsAm5sYuEF5ApLe7+JnfZaZAIjrcfCwUGqZCYyTJIGA+HWqBAblJTMBqKGJEnE1OwHYnBoa754ffX9vxZtYTFFqqrkr5OrEwKe6tEuDfGBIbgzxg0H5Coqb7h7KfqFQXhobOJ/PzwHxKSB/JkfUxbSFWF4bD9zaZUNyNxpYXIKstYtjd/4XcENy7nnejL5jiBGQr4H4TcuQNBBLZiiBkyWtc+IWACwE++VkxN5KzNB0zUUJDgedRyYC5Mv4pFwcEGha0sGl1zc1kGVw6I6stbN61ZRFiK9+CEhuIwbeJxFYa+eDhqQTJejjFJG39JSHBO3oBM3wA9bRTVMgkI9QtzOA3c0REq2HEzfSJFJfIglyiXgv+rsbxpdtIOkOIegilnZ0v0YxzWTwpTDWOYnHWirJ/wo+zgTeXxpFTYt64nzRSSKdfwNm89Xp+vornQAAAABJRU5ErkJggg==)
 */
export const UserPlayIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM11.53 11A9.53 9.53 0 0 0 2 20.53c0 .81.66 1.47 1.47 1.47h.22c.24 0 .44-.17.5-.4.29-1.12.84-2.17 1.32-2.91.14-.21.43-.1.4.15l-.26 2.61c-.02.3.2.55.5.55h5.73c.37 0 .61-.38.5-.73a7 7 0 0 1 3.65-8.61c.4-.2.46-.78.05-.95a9.5 9.5 0 0 0-3.61-.71h-.94Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M24 19a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-2.77-.2-3.33-2.5a.25.25 0 0 0-.4.2v5c0 .2.24.32.4.2l3.33-2.5c.14-.1.14-.3 0-.4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
